import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/upload-panorama', 'post'>;

export enum SceneType {
  FlatImage = 'FlatImage',
  MultiResPanorama = 'MultiResPanorama',
}

type Params = {
  name: string;
  file: File;
  sceneType: SceneType;
};

export const uploadSceneFactory = (apiClient: ApiClient) => {
  const uploadScene = async (variables: Params): Promise<void> => {
    const requestParams = mapInputToRequestParams(variables);
    await apiClient['/api/upload-panorama'].post(requestParams);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      formData: {
        name: input.name,
        formFile: input.file,
        processingSceneType: input.sceneType,
      },
    };
  };

  return uploadScene;
};
